module.exports = __webpack_public_path__ + "static/img/20221219_02.786b395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221219_02.png
// module id = HQI8
// module chunks = 0